import { css } from "@emotion/react";

import theme from "../../../styles/theme";
import { white } from "../../../styles/variables";

const { spacing } = theme;

export const appBar = css`
  background-color: ${white};
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.08);

  .MuiToolbar-root {
    @media (min-width: 600px) {
      min-height: 56px;
    }
  }
`;

export const header = css`
  flex: 1 1 auto;
`;

export const logo = css`
  width: 108px;
`;

export const container = css`
  width: 100%;
  margin-top: ${spacing(7)}px;
  padding-top: ${spacing(5)}px;
  padding-bottom: ${spacing(5)}px;
`;
